export default function Incrementer({ value, status, onChange, min = 0, max }) {
    const isSoldOut = (max === 0 && status === "sold_out")|| status === "sold_out" || status === "past";
    //former halli jekk veru jinbighu, latter two jekk ma tridx li jinxtraw iktar
    const isUpcoming = status === "upcoming" 

    function decrease() {
        if (value > min) {
            onChange(value - 1);
        }
    }

    function increase() {
        if (value < max) {
            onChange(value + 1);
        }
    }

    if (isSoldOut) {
        return (
            <span className="bg-black text-white px-1 text-lg uppercase">
                Sold out
            </span>
        );
    }

    if (isUpcoming) {
        return (
            <span className="bg-black text-white px-1 text-lg uppercase">
                Coming Soon
            </span>
        );
    }

    return (
        <div className="flex items-center gap-3">
            <button type="button" onClick={decrease} disabled={value <= min} className="px-3 py-1 text-5xl lg:text-3xl disabled:opacity-40">
                -
            </button>

            <span className="w-2 text-xl lg:text-lg text-center">{value}</span>

            <button type="button" onClick={increase} disabled={value >= max} className="px-3 py-1 text-5xl lg:text-3xl disabled:opacity-40">
                +
            </button>
        </div>
    );
}